import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "response-per-engine",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Track response effectiveness by enforcement engine.",
    domain: "responses",
    visual: "Ranked bars",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
